<template>

    <div class="accounts-page">
        <Header></Header>


        <section class="accounts-section" :data-profileId="profileId">
            <div class="container">
                <div class="row">
                    <div class="col-md-5" style="margin: 0 auto;">
                        <span>Welcome back, {{name}}!</span>
                        <h2 v-if="!bio">Fill out your account details</h2>
                        <h2 v-if="bio"></h2>
                        <form class="form" v-on:submit.prevent="accountsFormSubmit" enctype="multipart/form-data">
                            <div class="input-file-field form-input">
                                <p>Profile Image *</p>
                                <label for="profile-image">
                                    <span>{{profileImageName}}</span>
                                    <span>Choose File</span>
                                </label>
                                <input type="file" id="profile-image" ref="profileImageFile" v-on:change="handleProfileImageUpload">
                                <p class="error-input" v-if="profileImageFileFlag">Profile image is required</p>
                            </div>
                            <div class="input-file-field form-input">
                                <p>Background Image *</p>
                                <label for="bg-image">
                                    <span>{{bgImageName}}</span>
                                    <span>Choose File</span>
                                </label>
                                <input type="file" id="bg-image" ref="bgImageFile" v-on:change="handleBgImageUpload">
                                <p class="error-input" v-if="bgImageFileFlag">Profile banner is required</p>
                            </div>
                            <div class="input-select-field form-input">
                                <label for="your-profession">Profession * <span></span></label>
                                <select id="your-profession" v-model="profession"  v-on:change="yourProfession(profession)">
                                    <option value="">Select Profession</option>
                                    <option value="Dancer">Dancer</option>
                                    <option value="Musician">Musician</option>
                                    <option value="Visual Artist">Visual Artist</option>
                                    <option value="Cinematographer">Cinematographer</option>
                                    <option value="Other">Other</option>
                                </select>
                                <p class="error-input" v-if="professionFlag">Profession is required</p>
                            </div>
                            <div class="input-tags-field form-input">
                                <label>Skills</label>
                                <tags-input element-id="tags"
                                            v-model="selectedSkills"
                                            :only-existing-tags="true"
                                            :delete-on-backspace="true"
                                            :typeahead-hide-discard="true"
                                            placeholder="Add your skills"
                                            @tags-updated="skillsFuntion"
                                            :existing-tags="$options.skills"
                                            :typeahead="true"></tags-input>
                            </div>
                            <div class="input-select-field form-input country-list">
                                <!--<label for="your-tag">Country *<span></span></label>-->
                                <!--<select id="your-tag" v-model="country" v-on:change="getCities">-->
                                    <!--<option value="">Select Country</option>-->
                                    <!--<option :value="index" v-for="(data, index) in $options.myJson">{{index}}</option>-->
                                <!--</select>-->
                                <label>Country</label>
                                <v-select :options="$options.myJson" v-model="country" />
                            </div>
                            <div class="input-select-field form-input">
                                <!--<label for="your-tag">City *<span></span></label>-->
                                <!--<select id="your-tag1" v-model="location">-->
                                    <!--<option value="">Select City</option>-->
                                    <!--<option :value="data" v-for="(data, index) in citiesList">{{data}}</option>-->
                                <!--</select>-->
                                <!--<p class="error-input" v-if="locationFlag">Location is required</p>-->
                                <label>City</label>
                                <v-select :options="citiesList" v-model="location" />
                            </div>
                            <!--<div class="input-field form-input">-->
                                <!--<label for="your-location">Location *</label>-->
                                <!--<input type="text" placeholder="Your City" id="your-location" v-model="location"-->
                                       <!--v-on:blur="yourLocation(location)">-->
                                <!--<p class="error-input" v-if="locationFlag">Location is required</p>-->
                            <!--</div>-->
                            <div class="input-field form-input account-contact-fields social-m">
                                <label for="your-contact">Contact</label>
                                <div class="media-l">
                                    <input type="text" placeholder="Twitter Link" id="your-contact" v-on:blur="twitterFunction(twitterContact)" v-model="twitterContact">
                                    <p class="error-input" v-if="twitterContactFlag">Format: https://twitter.com/abc</p>
                                </div>
                                <div class="media-l">
                                    <input type="text" placeholder="Facebook Link" v-on:blur="facebookFunction(facebookContact)" v-model="facebookContact">
                                    <p class="error-input" v-if="facebookContactFlag">Format: https://www.facebook.com/abc</p>
                                </div>
                                <div class="media-l">
                                    <input type="text" placeholder="Instagram Link" v-on:blur="instagramFunction(instagramContact)" v-model="instagramContact">
                                    <p class="error-input" v-if="instagramContactFlag">Format: https://www.instagram.com/abc</p>
                                </div>
                                <div class="media-l">
                                    <input type="text" placeholder="YouTube Link" v-on:blur="youtubeFunction(youtubeContact)" v-model="youtubeContact">
                                    <p class="error-input" v-if="youtubeContactFlag">Format: https://www.youtube.com/watch?v=kjjnONI3non</p>
                                </div>
                                <div class="media-l">
                                    <input type="text" placeholder="website link" v-on:blur="websiteFunction(websiteContact)" v-model="websiteContact">
                                    <p class="error-input" v-if="websiteContactFlag">Format: https://www.cardboardstage.com</p>
                                </div>
                                <div class="media-l">
                                    <input type="text" placeholder="Email Id" v-model="emailIdContact">
                                </div>
                            </div>
                            <div class="input-field form-input account-contact-fields">
                                <label for="your-education">Higher Education</label>
                                <input type="text" placeholder="Higher Education College" id="your-education" v-model="college">
                                <input type="text" placeholder="Degree" v-model="degree">
                                <input type="text" placeholder="Graduation Year" v-model="passoutyear">
                            </div>
                            <div class="input-textarea-field form-input">
                                <label for="your-bio">Bio *</label>
                                <textarea placeholder="Something about you..." id="your-bio" v-model="bio" v-on:blur="bioFuntion(bio)"></textarea>
                                <p class="error-input" v-if="bioFlag">Bio is required</p>
                            </div>
                            <div class="input-textarea-field form-input">
                                <progress-bar
                                        v-if="progressFlag"
                                        :options="options"
                                        :value="value"
                                />
                            </div>

                            <div class="input-submit">

                                <input type="hidden" :value="profileId"/>
                                <input type="hidden" :value="imageId"/>
                                <button type="submit" v-if="!submitOnce">FINISH ACCOUNT SETUP</button>
                                <a href="javascript:void(0)" v-if="submitOnce">SUBMIT...</a>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
        <Gallery />
    </div>
</template>

<style>
    @import "../assets/css/tagsinput.css";
    .social-m .error-input{
        position: relative;
        bottom: 15px;
    }
</style>

<script>
    import Header from './Header'
    import Footer from './Footer'
    import Vue from 'vue'
    import axios from 'axios'
    import VoerroTagsInput from '@voerro/vue-tagsinput'
    import router from '../router'
    import VueToast from 'vue-toast-notification'
    import 'vue-toast-notification/dist/index.css'
    import contries from '@/assets/country.json'
    import cities from '@/assets/cities.json'
    import skills from '@/assets/skills.json'
    Vue.use(VueToast)
    import $ from "jquery"
    import ProgressBar from 'vuejs-progress-bar'
    Vue.use(ProgressBar)
    import vSelect from "vue-select";
    Vue.component("v-select", vSelect);
    import "vue-select/dist/vue-select.css";
    import Gallery from "./Gallery";


    export default {
        name: 'AccountsDetail',
        myJson: contries,
        myJsonCities: cities,
        skills: skills,
        components: {
            Gallery,
            'Header': Header,
            'Footer': Footer,
            'tags-input': VoerroTagsInput
        },
        data() {
            var userdata = localStorage.getItem('cbs_usertoken')
            if(userdata){
                userdata = JSON.parse(userdata)
            }
            var options = {
                text: {
                    color: '#FFFFFF',
                        shadowEnable: true,
                        shadowColor: '#000000',
                        fontSize: 14,
                        fontFamily: 'Helvetica',
                        dynamicPosition: false,
                        hideText: false
                },
                progress: {
                    color: '#2dbd2d',
                        backgroundColor: '#333333'
                },
                layout: {
                    height: 35,
                        width: 445,
                        verticalTextAlign: 61,
                        horizontalTextAlign: 43,
                        zeroOffset: 0,
                        strokeWidth: 30,
                        progressPadding: 0,
                        type: 'line'
                }
            }
            return {
                name: '',
                value: 1,
                options: options,
                progressFlag: false,
                location: '',
                locationFlag: false,
                profession: '',
                professionFlag: false,
                twitterContact: '',
                twitterContactFlag: false,
                bgImageFileFlag: false,
                profileImageFileFlag: false,
                facebookContact: '',
                facebookContactFlag: false,
                instagramContact: '',
                instagramContactFlag: false,
                youtubeContact: '',
                websiteContact: '',
                emailIdContact: '',
                youtubeContactFlag: false,
                websiteContactFlag: false,
                emailContactFlag: false,
                bio: '',
                college: '',
                degree: '',
                passoutyear: '',
                bioFlag: false,
                bgImageName: 'Select Image',
                profileImageName: 'Select Image',
                userId: userdata.user.id,
                userdata: userdata,
                profileId: '',
                submitOnce: false,
                profile: '',
                imageId: '',
                selectedSkills: [],
                tags: [],
                skillsFlag: false,
                isfeatured: false,
                country: '',
                city: '',
                citiesList: ["Please select country first"],
                msg: 'Welcome to Your Vue.js App'
            }
        },
        mounted () {
            // let $this = this
            // $.each(this.$options.myJson, function (key, val) {
            //     let test = []
            //     $.each(val, function(i, el){
            //         if($.inArray(el, test) === -1) test.push(el);
            //     });
            //     $this.$options.myJson[key] = test
            // })
            // var myJSON = JSON.stringify(this.$options.myJson);
            // console.log(myJSON)
            // localStorage.setItem('myJSON', myJSON)
            axios
                .get('/getprofile', {
                    params: {
                        userId: this.userId
                    }
                })
                .then(response => {
                    this.name = response.data.name
                    this.profileId = response.data.profiles[0]._id
                    this.country = response.data.profiles[0].country
                    this.citiesList = this.$options.myJson[this.country]
                    this.location = response.data.profiles[0].location
                    this.profession = response.data.profiles[0].profession
                    // this.selectedSkills = response.data.profiles[0].skills
                    this.isfeatured = response.data.profiles[0].isfeatured
                    this.twitterContact = response.data.profiles[0].twitterContact
                    this.facebookContact = response.data.profiles[0].facebookContact
                    this.instagramContact = response.data.profiles[0].instagramContact
                    this.youtubeContact = response.data.profiles[0].youtubeContact
                    this.websiteContact = response.data.profiles[0].websiteContact
                    this.emailIdContact = response.data.profiles[0].emailIdContact
                    this.bio = response.data.profiles[0].bio
                    this.college = response.data.profiles[0].college
                    this.degree = response.data.profiles[0].degree
                    this.passoutyear = response.data.profiles[0].passoutyear
                    this.profileImageName = response.data.profiles[0].images[0].profileImageName
                    this.bgImageName = response.data.profiles[0].images[0].bgImageName
                    this.imageId = response.data.profiles[0].images[0]._id

                    if(response.data.profiles[0].skills){
                        var list = []
                        response.data.profiles[0].skills.map(function(value, key) {
                            list.push({key: value, value: value})
                        })
                    }
                    this.selectedSkills = list
                    var tags = []
                    this.selectedSkills.map(function(value, key) {
                        tags.push(value.value)
                    })
                    this.tags = tags

                })
                .catch(error => console.log(error))

            let $this = this
            $('.country-list .vs__search').blur(function (event) {
                setTimeout(function () {
                    $this.getCities()
                }, 300)
            });
        },
        methods: {
            twitterFunction: function(value) {
                if(!this.validation(value)){
                    this.twitterContactFlag = true
                } else {
                    this.twitterContactFlag = false
                }
            },
            facebookFunction: function(value) {
                if(!this.validation(value)){
                    this.facebookContactFlag = true
                } else {
                    this.facebookContactFlag = false
                }
            },
            instagramFunction: function(value) {
                if(!this.validation(value)){
                    this.instagramContactFlag = true
                } else {
                    this.instagramContactFlag = false
                }
            },
            youtubeFunction: function(value) {
                if(!this.validation(value)){
                    this.youtubeContactFlag = true
                } else {
                    this.youtubeContactFlag = false
                }
            },
            websiteFunction: function(value) {
                if(!this.validation(value)){
                    this.websiteContactFlag = true
                } else {
                    this.websiteContactFlag = false
                }
            },
            validation: function(value) {
                return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(value)
            },
            getCities: function (event) {
                this.citiesList = this.$options.myJsonCities[this.country]
            },
            progressDelay: function(){
                var numberOfTimes = ''
                var delay = ''
                var $this = this
                if(this.value === 1){
                    numberOfTimes = 98
                    delay = 300
                } else {
                    numberOfTimes = 100 - this.value
                    delay = 10
                }
                for (let i = 0; i < numberOfTimes; i++) {
                    setTimeout( function () {
                        if($this.value < 100){
                            $this.value = $this.value + 1
                        }
                    }, delay * i)
                }
            },
            yourProfession: function (msg) {
                if (!msg) {
                    this.professionFlag = true
                } else {
                    this.professionFlag = false
                }
            },
            skillsFuntion(msg){
                if (!this.selectedSkills.length) {
                    this.skillsFlag = true
                } else {
                    this.skillsFlag = false
                    var tags = []
                    this.selectedSkills.map(function(value, key) {
                        tags.push(value.value)
                    })
                    this.tags = tags
                }
            },
            yourLocation: function (msg) {
                if (!msg) {
                    this.locationFlag = true
                } else {
                    this.locationFlag = false
                }
            },
            bioFuntion: function (msg) {
                if (!msg) {
                    this.bioFlag = true
                } else {
                    this.bioFlag = false
                }
            },
            handleBgImageUpload(){
                this.bgImageFile = this.$refs.bgImageFile.files[0]
                this.bgImageName = this.$refs.bgImageFile.files[0].name
            },
            handleProfileImageUpload(){
                this.profileImageFile = this.$refs.profileImageFile.files[0]
                this.profileImageName = this.$refs.profileImageFile.files[0].name
            },
            profileUpload () {
                // let facebook = ''
                // let twitter = ''
                // let instagram = ''
                // let youtube = ''
                // if(this.facebookContact && this.facebookContact.includes('facebook.com')){
                //     facebook = this.facebookContact
                // } else if(this.facebookContact) {
                //     facebook = 'https://www.facebook.com/'+this.facebookContact
                // }
                // if(this.twitterContact && this.twitterContact.includes('twitter.com')){
                //     twitter = this.twitterContact
                // } else if(this.twitterContact) {
                //     twitter = 'https://twitter.com/'+this.twitterContact
                // }
                // if(this.instagramContact && this.instagramContact.includes('instagram.com')){
                //     instagram = this.instagramContact
                // } else if(this.instagramContact) {
                //     instagram = 'https://www.instagram.com/'+this.instagramContact
                // }
                // if(this.youtubeContact && this.youtubeContact.includes('youtube.com/channel')){
                //     youtube = this.youtubeContact
                // } else if(this.youtubeContact) {
                //     youtube = 'https://www.youtube.com/channel/'+this.youtubeContact
                // }
                try {
                    axios.post('/editprofile', {
                        profession: this.profession,
                        skills: this.tags,
                        location: this.location,
                        country: this.country,
                        isfeatured: this.isfeatured,
                        twitterContact: this.twitterContact,
                        facebookContact: this.facebookContact,
                        instagramContact: this.instagramContact,
                        youtubeContact: this.youtubeContact,
                        websiteContact: this.websiteContact,
                        emailIdContact: this.emailIdContact,
                        college: this.college,
                        degree: this.degree,
                        passoutyear: this.passoutyear,
                        bio: this.bio,
                        imageId: this.imageId,
                        profileId: this.profileId
                    },{
                        headers: {
                            "content-type": "application/json",
                            "x-api-key": this.userdata.token
                        }
                    }).then(res => {
                        console.log(res)
                        this.progressDelay()
                        this.submitOnce = false
                        Vue.$toast.open(
                            {
                                message: 'Profile updated!',
                                type: 'success',
                                position: 'top-right'
                                // all other options
                            }
                        )
                        this.progressFlag = false
                        this.value = 1
                        router.push({ path: '/artists/'+this.userId })
                    }).catch(err => {
                        console.log(err)
                    })
                } catch (e) {
                    console.log(e)
                }
            },
            accountsFormSubmit: function (event) {
                if(!this.profileImageFile){
                    this.bgImageFileFlag = true
                } else {
                    this.bgImageFileFlag = false
                }
                if(!this.bgImageFile){
                    this.profileImageFileFlag = true
                } else {
                    this.profileImageFileFlag = false
                }
                if(!this.profession){
                    this.yourProfession()
                }
                if(!this.location){
                    this.yourLocation()
                }
                if(!this.bio){
                    this.bioFuntion()
                }
                if(!this.profileImageName || !this.bgImageName || !this.profession || !this.location || !this.bio){
                    Vue.$toast.open(
                        {
                            message: 'Please fill all the required fields',
                            type: 'error',
                            position: 'top-right'
                            // all other options
                        }
                    )
                    return
                }
                this.submitOnce = true
                this.progressFlag = true
                this.progressDelay()
                if(this.profileImageFile || this.bgImageFile){
                    const formData = new FormData()
                    if(this.profileImageFile){
                        formData.append('profileImageFile', this.profileImageFile)
                        formData.append('profileImageName', this.profileImageName)
                    }
                    if(this.bgImageFile){
                        formData.append('bgImageFile', this.bgImageFile)
                        formData.append('bgImageName', this.bgImageName)
                    }
                    formData.append('imageId', this.imageId)
                    try {
                        axios.post('/profileImageEdit', formData, {
                            headers: {
                                "content-type": "application/json",
                                "x-api-key": this.userdata.token
                            }
                        }).then(res => {
                            if(res.data){
                                this.userdata.user.profileImage = res.data
                                localStorage.setItem('cbs_usertoken', JSON.stringify(this.userdata))
                            }
                                this.profileUpload()
                            console.log(res)
                        }).catch(err => {
                            console.log(err)
                        })
                    } catch (e) {
                        console.log(e)
                    }
                } else {
                    this.profileUpload()
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/AccountsDetail.vue